// extracted by mini-css-extract-plugin
export default {"root":"EHRsvTrdz8I9OxyITOza","icon":"BJplHqJk8vF8eJ4odQiy","placeHolderShimmer":"L7JwwO1BEBo0q6MPFXiX"};